import React, { useEffect, useRef } from 'react';
import { timestampFormatter } from "../../utils/utils";
import PropTypes from 'prop-types';

// Normalise the signal payload to an array. Depending on the DB column type
// (text vs. json/jsonb) the backend may return either a JSON string like
// "[]" (local) or an already-parsed array (production). Guard both, plus
// null/empty, so JSON.parse is never called on a non-string.
const toSignalRows = (data) => {
  if (Array.isArray(data)) return data;
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const SignalPopup = ({ data, onClose }) => {
  const closeRef = useRef(null);
  const rows = toSignalRows(data);

  // Keyboard accessibility (feature 027): close on Escape and move focus to the
  // Close button on open, so the dialog is fully operable without a mouse.
  useEffect(() => {
    const onKeyDown = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', onKeyDown);
    if (closeRef.current) closeRef.current.focus();
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className="popup-overlay">
      <div className="popup" role="dialog" aria-modal="true" aria-label="Signal information">
        <h2>Signal information</h2><hr />
        <div className="popup-table">
            <table style={{ width: "100%", textAlign: "left" }}>
                <thead>
                <tr>
                    <th>Datetime</th>
                    <th>Value</th>
                </tr>
                </thead>
                <tbody>
                {rows.length > 0 ? (
                    rows.map((item, index) => {
                    const key = Object.keys(item)[0];
                    const value = item[key];
                    return (
                        <tr key={index}>
                        <td>{timestampFormatter(key)}</td>
                        <td>{value}</td>
                        </tr>
                    );
                    })
                ) : (
                    <tr>
                    <td colSpan="2" style={{ textAlign: "center" }}>
                        No data available
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        <button ref={closeRef} className="search-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

SignalPopup.propTypes = {
  data: PropTypes.any,
  onClose: PropTypes.func,
};

export default SignalPopup;
